module.exports = __webpack_public_path__ + "img/logo-diario.2d641777.png";